import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

const OpsViewerPreset = definePreset(Material, {
  semantic: {
    
    primary: {
      50: '#e8f5ea',
      100: '#c8e6cd',
      200: '#a5d6a7',
      300: '#81c784',
      400: '#4caf50',
      500: '#279242',
      600: '#207435',
      700: '#175025',
      800: '#123d1c',
      900: '#0d2b13',
      950: '#07180a'
    },
    formField: {
      paddingX: '0.25rem',
      paddingY: '0.25rem',
      sm: {
        paddingX: '0.25rem',
        paddingY: '0.25rem'
      },
      lg: {
        paddingX: '0.5rem',
        paddingY: '0.5rem'
      }
    },
    colorScheme: {
      dark: {
        text: {
          color: 'rgba(255,255,255,.87)',
          mutedColor: 'rgba(255,255,255,.60)'
        }
      }
    }
  },
  components: {
    accordion: {
      header: {
       // background: '#279242',
        color: 'rgba(255,255,255,.87)',
        hoverBackground: '#175025',
        hoverColor: 'rgba(255,255,255,.87)',
        activeBackground: '#279242',
        activeColor: 'rgba(255,255,255,.87)',
        activeHoverBackground: '#175025',
        activeHoverColor: 'rgba(255,255,255,.87)'
      },
      content: {
        background: '#1e1e1e',
        color: 'rgba(255,255,255,.87)',
        padding: '0.5rem'
      }
    }
    ,
    button: {
      root: {
        paddingX: '0.75rem',
        sm: {
          fontSize: '0.875rem',
          paddingX: '1rem',
          paddingY: '0.5rem'
        }
      },
      colorScheme: {
        dark: {
          root: {
            primary: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            secondary: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            success: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            info: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            warn: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            help: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            danger: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            },
            contrast: {
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff'
            }
          }
        }
      }
    },
    datatable: {
      header: {
        background: '#252525',
        borderColor: '#191919'
      },
      headerCell: {
        background: '#252525',
        borderColor: '#191919',
        padding: '0.5rem'
      },
      row: {
        background: '#323232',
        hoverBackground: '#323232'
      },
      bodyCell: {
        borderColor: '#191919',
        padding: '0.25rem'
      },
      footerCell: {
        borderColor: '#191919',
        padding: '0.25rem'
      }
    }
  }
});

export default OpsViewerPreset;
